import { Link } from "react-router-dom";
import { ArrowRight, Award, Brain, Sprout, FileBarChart, Layers } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { SectionHead } from "@/components/site/SectionHead";
import { Sparkle } from "@/components/site/Sparkle";

const WHY = [
  [Award, "18+ Years of Digital Marketing Experience", "Over 18 years of hands-on experience helping businesses grow through Google Ads, Meta Ads, SEO, analytics and conversion optimisation."],
  [Brain, "Marketing Meets Psychology", "Successful marketing starts with understanding people. I combine my digital marketing experience with training in psychology, NLP and behavioural science to inform strategies that consider customer motivations, decision-making and behaviour."],
  [Sprout, "Your Growth Matters", "I believe in building long-term relationships and helping businesses succeed. When your business grows, we grow together."],
  [FileBarChart, "Clear, Honest Reporting", "Reports focused on leads, sales and cost, explained in plain English."],
  [Layers, "Flexible Support", "From one-off audits to ongoing management, as your business grows."],
];

export const WhySection = () => (
  <section className="bg-[#F5F0FF] py-16 sm:py-28" data-testid="why-section">
    <div className="mx-auto grid max-w-7xl gap-10 px-5 sm:px-8 lg:grid-cols-[1fr_1.4fr] lg:gap-16">
      <div className="lg:sticky lg:top-32 lg:self-start">
        <SectionHead eyebrow="Why Digital AdDoctor?" title={<>Marketing expertise, <span className="serif-accent font-normal text-[#581C87]">with a <Sparkle>human touch.</Sparkle></span></>}
          text="Digital marketing experience, psychology, NLP and behavioural science, combined with a genuinely personal service." />
        <Reveal delay={0.1}><Link to="/about-freya-jones" className="btn-ghost mt-8" data-testid="why-about-link">How I work <ArrowRight className="h-4 w-4" /></Link></Reveal>
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        {WHY.map(([I, t, d], i) => (
          <Reveal key={t} delay={(i % 2) * 0.08} className={`h-full ${WHY.length % 2 && i === WHY.length - 1 ? "sm:col-span-2" : ""}`}>
            <div className="h-full rounded-[24px] bg-white p-6 transition-transform duration-500 hover:-translate-y-1 sm:p-7" data-testid={`why-card-${i}`}>
              <I className="h-6 w-6 text-[#7C3AED]" />
              <h3 className="mt-4 text-lg font-extrabold text-[#13052A]">{t}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
